import './app-info.scss';
//import Collapse from 'react-bootstrap/Collapse';
//import 'bootstrap/dist/css/bootstrap.css';
import { useTranslation } from 'react-i18next';
// import { callGTMAnalytics } from '../../helper/analyticsTag';
// import { useRecoilState } from 'recoil';
// import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';

interface IProps {
  isTableDataExists: boolean;
  isErrorMessageShown: boolean;
}

const AppInfo: React.FC<IProps> = () => {
  // ! for language
  const { t } = useTranslation();

  // const [isToolOverviewOpen, setIsToolOverviewOpen] = useState(true);
  // const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  // const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(true);
  // const [utagData] = useRecoilState(utagObjectAtom);

  // useEffect(() => {
  //   if (isTableDataExists) {
  //     setIsToolOverviewOpen(false);
  //     setIsResourcesOpen(false);
  //     setIsDisclaimerOpen(false);
  //   } else if (isErrorMessageShown) {
  //     setIsToolOverviewOpen(false);
  //     setIsResourcesOpen(true);
  //     setIsDisclaimerOpen(false);
  //   } else {
  //     setIsToolOverviewOpen(true);
  //     setIsResourcesOpen(false);
  //     setIsDisclaimerOpen(true);
  //   }
  // }, [isTableDataExists, isErrorMessageShown]);

  return (
      <div className="w-full">
      <div className="dk-card p-2 mt-2">
        <p className="info-header">{t('xref-tool-overview')}</p>
        <p>{t('xref-dgk-cross-reference-tool-is-intended')}</p>
        <p>{t('xref-to-use-the-tool')}</p>
        <ul>
            <li>
            {t('xref-enter-a')} <strong>{t('xref-complete')}</strong>
            {t('xref-manufacturer-part-number-into-the-search-field')}
              {/* <a
                href="https://forum.digikey.com/"
                target="_blank"
                rel="noreferrer"
                id="tech-forum-other-link"
                track-data="ref_page_event=No Results - TechForum"
                onClick={() => callGTMAnalytics(utagData, "No Results - TechForum")}
              >
                {t('xref-techforum')}
              </a>{' '}
              - {t('xref-cross-reference-category')} */}
            </li>
            <li>{t('xref-available-results-are-displayed-in-a-table')}</li>
            <li>{t('xref-cells-highlighted-in-green-indicate')}</li>
            <li>{t('xref-the-checkbox-located-in-the-far-left-column')}</li>
        </ul>
        <p>{t('xref-each-column-allows-sorting')}</p>

        <p className="info-header">{t('xref-other-resources')}</p>
        <ul>
            <li>
            <a
            href="https://forum.digikey.com/"
            target="_blank"
            rel="noreferrer"
            className="dk-link"
            >
            {t('xref-techforum')}
            </a>{' '}
            - {t('xref-cross-reference-category')}
            </li>
        </ul>

        <p className="info-header">{t('xref-disclaimer')}</p>
        <p>{t('xref-the-information-available')}</p>
      </div>
    </div>

  );
};

export default AppInfo;
